<template>
  <div :class="ui.bkgdColor">
    <!-- <div v-show="false"> {{getTasksListCounter}} </div> -->
    <v-layout row class="ml-3 mt-3 mr-3">
      <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
        {{tasksObj.title}}
      </v-chip>
      <v-spacer/>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading"
      v-if="enableAssetCount">
        <v-icon left :color="ui.btnColor">
          emoji_transportation
        </v-icon>
        <div v-if="this.getDetailStats === null">
          NA
        </div>
        <div v-else>
          {{this.getDetailStats.na1}}
        </div>
      </v-chip>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">playlist_add</v-icon>
        <div v-if="getTasksList.length === null">
          0
        </div>
        <div v-else>
          {{getTasksList.length}}
        </div>
      </v-chip>
    </v-layout>
    <v-layout row class="ml-3 mt-0 mr-3"
    v-if="enableAssetCount">
      <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
        <div class="hidden-sm-and-up">
          One tasks resource per asset.
        </div>
        <div class="hidden-xs-only">
          Note: all tasks resources are per asset basis.
        </div>
      </v-chip>
      <v-spacer/>
    </v-layout>
    <TasksList :tasks="{editUnlock: true, attach: []}"/>
    <v-layout row class="ml-3 mt-3 mr-3">
      <v-spacer/>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">schedule</v-icon>
        <div v-if="getTasksList.length === null">
          0
        </div>
        <div v-else>
          {{this.calcTaskListHours(this.getTasksList)}} hrs
        </div>
      </v-chip>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">person</v-icon>
        <div v-if="getTasksList.length === null">
          0
        </div>
        <div v-else>
          {{this.calcTaskListPersonHours(this.getTasksList)}} phrs
        </div>
      </v-chip>
    </v-layout>
    <v-layout row class="mr-1 mt-4"
    v-if="this.getCurrentPage !== '/worktooldetail'">
      <v-spacer/>
      <TasksNew/>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import TasksNew from "@/work/tasks/components/TasksNew";
import TasksList from "@/work/tasks/components/TasksList";
import tasksFunctions from "@/data/functions/mixins/tasksFunctions.js";

export default {
  // eslint-disable-next-line
  mixins: [apptheme, tasksFunctions],
  components: {
    TasksList,
    TasksNew
  },
  props: {
    tasks: {
      type: Object
    }
  },
  methods: {
    editResource() {
      // eslint-disable-next-line
      this.$store.dispatch("changeResourceListDisplay", this.list);
      this.enableEditBtn = true;
    }
  },
  computed: {
    ...mapGetters([
      "getDetailStats",
      "getDetailLink",
      "getTasksList",
      "getTasksListCounter",
      "getCurrentPage",
      "getWork"
    ]),
    enableAssetCount() {
      let logic = false;
      if (this.getCurrentPage === "/maintplandetail") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    tasksObj() {
      let obj = {
        title: ""
      };
      if (this.getDetailLink !== null) {
        if (
          this.getDetailLink.wpdid !== undefined &&
          this.getDetailLink.wpdid !== ""
        ) {
          let wpid = this.getDetailLink.wpid;
          obj.title = "Tasks " + wpid;
        } else {
          obj.title = "Tasks Standalone";
        }
      } else {
        obj.title = "Tasks";
      }
      return obj;
    },
    list() {
      // eslint-disable-next-line
      if (this.getTasksList !== undefined && this.getTasksList.length !== 0) {
        return this.getTasksList; // used for new tasks
      } else if (this.getTasksList === undefined) {
        return [];
      } else if (this.getTasksList.length !== 0) {
        return this.getTasksList;
      } else {
        return [];
      }
    },
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableEditBtn: false
    };
  }
};
</script>
